import { SiteName } from 'types/Site';
import BrandTypes from 'constants/brand';
import { Roundel } from '../../types/Product';

const ImageFormats = [
  {
    format: 'webp',
    type: 'webp',
  },
  {
    format: 'jpg',
    type: 'jpeg',
  },
];

const GetMainImages = () => ({
  mainSlider: [
    {
      media: '(max-width: 430px)',
      template: '$pdp_300x400_x2$',
    },
    {
      media: '(min-width: 431px) and (max-width: 991px)',
      template: '$pdp_990x1320_x2$',
    },
    {
      media: '(min-width: 992px)',
      template: '$pdp_576x768_x2$',
    },
  ],
});

export const GetValidMediaUrl = (site: SiteName): string => {
  switch (site) {
    case BrandTypes.VERYIE:
      return 'https://media.very.ie/i/littlewoodsireland';
    case BrandTypes.LITTLEWOODS:
      return 'https://media.littlewoods.com/i/littlewoods';
    default:
      return 'https://media.very.co.uk/i/very';
  }
};

const GetImageUrl = ({
  identifier,
  template,
  format,
  roundel,
  isVideo = false,
  site,
}: {
  identifier: string;
  template: string;
  format: string;
  roundel?: Roundel;
  isVideo?: boolean;
  site: SiteName;
}) => {
  const mediaUrl = GetValidMediaUrl(site);
  if (isVideo) {
    const videoUrl = mediaUrl.replace('/i/', '/v/');

    return `${videoUrl}/${identifier}?${template}`;
  }

  return `${mediaUrl}/${identifier}?${template}&fmt=${format}${roundel ? `&$roundel_very$&p1_img=${roundel.imageUrlPath}` : ''}`;
};

const GetImageSources = (sizes: Array<{ media: string; template: string }>) => {
  const sources: Array<{ media: string; template: string; format: string; type: string }> = [];

  sizes.forEach((size) => {
    ImageFormats.forEach(({ format, type }) => {
      sources.push({
        ...size,
        format,
        type,
      });
    });
  });

  return sources;
};

export { GetMainImages, GetImageUrl, GetImageSources };
